import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Handles our own Google OAuth return: exchanges the ?code for a JWT session cookie.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setCtx } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const run = async () => {
      if (!code) {
        navigate("/login?error=google", { replace: true });
        return;
      }
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/api/auth/google/callback", { code, redirect_uri: redirectUri });
        setCtx(data);
        navigate(data.user.onboarded ? "/" : "/onboarding", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    };
    run();
  }, [navigate, setCtx]);

  return (
    <div className="flex h-screen items-center justify-center bg-background" data-testid="google-callback">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
